import React, { useEffect, useState } from "react";
import Select from "react-select";
import '../../CSS/Global.css';



const ItemTable = ({ items, setItems, setSubtotal }) => {
    const url = process.env.REACT_APP_LINK;
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [itemsOptions, setItemsOptions] = useState([]);

    const fetchServiceData = async () => {
        try {
            const res = await fetch(`${url}/offerings/all/${isLoggedIn.user_id}`);
            const data = await res.json();

            // Assuming each offering has a `sports_offered` or `name` field
            const options = data.map((item) => ({
                value: item.sports_offered || item.name, // Adjust key if needed
                label: item.sports_offered || item.name,
            }));

            setItemsOptions(options);
        } catch (error) {
            console.error("Error fetching offerings:", error);
        }
    };

    const handleInputChange = (id, field, value) => {
        const updatedRows = items.map((row) =>
            row.id === id ? { ...row, [field]: value } : row
        );
        setItems(updatedRows);
        const newSubtotal = updatedRows.reduce((acc, row) => {
            const qty = parseFloat(row.quantity) || 0;
            const rate = parseFloat(row.rate) || 0;
            const discount = parseFloat(row.discount) || 0;
            const tax = parseFloat(row.tax) || 0;

            const amount = qty * rate * (1 - discount / 100) * (1 + tax / 100);
            return acc + amount;
        }, 0);
        setSubtotal(newSubtotal);
    };


    const handleAddRow = () => {
        setItems([
            ...items,
            { id: Date.now(), item: null, quantity: "", rate: "", discount: "", tax: "" },
        ]);
    };

    const handleDeleteRow = (id) => {
        setItems(items.filter((row) => row.id !== id));
    };

    useEffect(() => {
        fetchServiceData();
    }, [])

    return (
        <>
            <div className="item-table-container">
                <table className="item-table">
                    <thead>
                        <tr>
                            <th className="item-table-select-item">Items</th>
                            <th>Quantity</th>
                            <th>Rate / Amount</th>
                            <th>Discount (%)</th>
                            <th>Tax (%)</th>
                            <th>Amount</th>
                            <th className="item-table-delete">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((row) => (
                            <tr key={row.id}>
                                <td className="item-table-select-item-td">
                                    <Select
                                        options={itemsOptions}
                                        value={row.item}
                                        onChange={(selectedOption) =>
                                            handleInputChange(row.id, "item", selectedOption)
                                        }
                                        placeholder="Select Item"
                                        className="item-table-select-item"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        value={row.quantity}
                                        onChange={(e) =>
                                            handleInputChange(row.id, "quantity", e.target.value)
                                        }
                                        placeholder="Quantity"
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        value={row.rate}
                                        onChange={(e) =>
                                            handleInputChange(row.id, "rate", e.target.value)
                                        }
                                        placeholder="Rate"
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        value={row.discount}
                                        onChange={(e) =>
                                            handleInputChange(row.id, "discount", e.target.value)
                                        }
                                        placeholder="Discount"
                                        min="0"
                                        max="100"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        value={row.tax}
                                        onChange={(e) =>
                                            handleInputChange(row.id, "tax", e.target.value)
                                        }
                                        placeholder="Tax"
                                        min="0"
                                        max="100"
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </td>
                                <td className="item-table-amount">
                                    {(
                                        (row.quantity || 0) *
                                        (row.rate || 0) *
                                        (1 - (row.discount || 0) / 100) *
                                        (1 + (row.tax || 0) / 100)
                                    ).toFixed(2)}
                                </td>
                                <td className="item-table-delete">
                                    <button
                                        onClick={() => handleDeleteRow(row.id)}
                                        className="delete-btn"
                                    >
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <button type="button" onClick={handleAddRow} className="add-row-btn">
                    Add item
                </button>
            </div>

            <div className="item-table-mobile">
                <ItemTableMobile itemsOptions={itemsOptions} items={items} setItems={setItems} setSubtotal={setSubtotal} />
            </div>
        </>
    );
};

export default ItemTable;






const ItemTableMobile = ({ itemsOptions, items, setItems, setSubtotal }) => {
    // const [items, setItems] = useState([
    //     { id: Date.now(), item: null, quantity: "", rate: "", discount: "", tax: "", amount: 0 },
    // ]);

    const calculateAmount = (quantity, rate, discount, tax) => {
        return (
            (quantity || 0) *
            (rate || 0) *
            (1 - (discount || 0) / 100) *
            (1 + (tax || 0) / 100)
        ).toFixed(2);
    };

    const handleInputChange = (id, field, value) => {
        const updatedItems = items.map((item) =>
            item.id === id ? { ...item, [field]: value } : item
        );
        setItems(updatedItems);
        const newSubtotal = updatedItems.reduce((acc, row) => {
            const qty = parseFloat(row.quantity) || 0;
            const rate = parseFloat(row.rate) || 0;
            const discount = parseFloat(row.discount) || 0;
            const tax = parseFloat(row.tax) || 0;

            const amount = qty * rate * (1 - discount / 100) * (1 + tax / 100);
            return acc + amount;
        }, 0);
        setSubtotal(newSubtotal);
    };

    const handleAddRow = () => {
        setItems([
            ...items,
            { id: Date.now(), item: null, quantity: "", rate: "", discount: "", tax: "", amount: 0 },
        ]);
    };

    const handleDeleteRow = (id) => {
        setItems(items.filter((item) => item.id !== id));
    };

    return (
        <div className="oms-modal-form">
            {items.map((item) => (
                <div key={item.id} className="item-row">
                    <div className="oms-form-group">
                        <label htmlFor={`item-${item.id}`} className="oms-form-label">
                            Item
                        </label>
                        <Select
                            options={itemsOptions}
                            value={item.item}
                            onChange={(selectedOption) =>
                                handleInputChange(item.id, "item", selectedOption)
                            }
                            placeholder="Select Item"
                            id={`item-${item.id}`}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`quantity-${item.id}`} className="oms-form-label">
                            Quantity
                        </label>
                        <input
                            type="number"
                            id={`quantity-${item.id}`}
                            placeholder="Enter quantity"
                            value={item.quantity}
                            onChange={(e) =>
                                handleInputChange(item.id, "quantity", parseFloat(e.target.value))
                            }
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`rate-${item.id}`} className="oms-form-label">
                            Rate/Amount
                        </label>
                        <input
                            type="number"
                            id={`rate-${item.id}`}
                            placeholder="Enter Rate"
                            value={item.rate}
                            onChange={(e) =>
                                handleInputChange(item.id, "rate", parseFloat(e.target.value))
                            }
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`discount-${item.id}`} className="oms-form-label">
                            Discount (%)
                        </label>
                        <input
                            type="number"
                            id={`discount-${item.id}`}
                            placeholder="Enter discount"
                            value={item.discount}
                            onChange={(e) =>
                                handleInputChange(item.id, "discount", parseFloat(e.target.value))
                            }
                            min="0"
                            max="100"
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`tax-${item.id}`} className="oms-form-label">
                            Tax (%)
                        </label>
                        <input
                            type="number"
                            id={`tax-${item.id}`}
                            placeholder="Enter tax"
                            value={item.tax}
                            onChange={(e) =>
                                handleInputChange(item.id, "tax", parseFloat(e.target.value))
                            }
                            min="0"
                            max="100"
                            onWheel={(e) => e.target.blur()}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor={`amount-${item.id}`} className="oms-form-label">
                            Total Amount
                        </label>
                        <input
                            type="text"
                            id={`amount-${item.id}`}
                            value={calculateAmount(item.quantity, item.rate, item.discount, item.tax)}
                            readOnly
                            className="readonly-input"
                        />
                    </div>
                    <button
                        type="button"
                        onClick={() => handleDeleteRow(item.id)}
                        className="mobile-delete-row-btn"
                    >
                        <i class="fa-solid fa-trash-can"></i>  Delete item
                    </button>
                </div>
            ))}
            <button type="button" onClick={handleAddRow} className="add-row-btn">
                Add item
            </button>
        </div>
    );
};
